export function combineStringEntries(primary?: string, secondary?: string | number): string {
  if (primary && secondary) {
    return `${primary} (${secondary})`
  }

  return primary ?? (secondary ? String(secondary) : undefined) ?? 'N/A'
}
